import { motion } from "framer-motion";
import { Signal, Coins, FileCheck, CreditCard, Zap, Smartphone } from "lucide-react";
import { useT } from "@/i18n";

const icons = [Signal, Coins, FileCheck, CreditCard, Zap, Smartphone];
const spans = ["md:col-span-2", "", "", "md:col-span-2", "", ""];
const containerVariants = { hidden: {}, visible: { transition: { staggerChildren: 0.08 } } };
const itemVariants = { hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0, transition: { duration: 0.5 } } };

export default function BenefitsSection() {
  const t = useT();

  return (
    <section data-testid="benefits-section" className="py-24 sm:py-32 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }} className="text-center mb-16">
          <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-orange-400 mb-4">{t.benefits.overline}</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-white">{t.benefits.title}</h2>
        </motion.div>
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
          {t.benefits.items.map((benefit, index) => {
            const Icon = icons[index];
            return (
              <motion.div key={index} variants={itemVariants} data-testid={`benefit-card-${index}`}
                className={`glass-card rounded-3xl p-8 flex flex-col justify-end min-h-[220px] transition-all duration-300 group ${spans[index]}`}>
                <div className="mb-4">
                  <div className="w-12 h-12 rounded-2xl bg-orange-500/10 border border-orange-500/20 flex items-center justify-center mb-4 group-hover:bg-orange-500/20 transition-colors">
                    <Icon className="w-6 h-6 text-orange-400" strokeWidth={1.5} />
                  </div>
                </div>
                <h3 className="text-xl sm:text-2xl font-medium tracking-tight text-white mb-2">{benefit.title}</h3>
                <p className="text-sm sm:text-base text-slate-400 leading-relaxed">{benefit.desc}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
